import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsStackexchangeComponent } from './simple-icons-stackexchange.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsStackexchangeComponent ],
    exports:      [ SimpleIconsStackexchangeComponent ],
    bootstrap:    []
})
export class SimpleIconsStackexchangeModule {}
